import { Controller } from '@hotwired/stimulus';

/**
 * Toggles the container width between normal (1280px) and full-width (100%).
 * Persists the state in localStorage.
 *
 * Usage:
 *   div[data-controller="container-width-toggle"]
 *     a[data-action="click->container-width-toggle#toggle"]
 *       i[data-container-width-toggle-target="icon"]
 */
export default class extends Controller {
  static get values() {
    return {
      storageKey: { type: String, default: 'smart_dialog:profile_edit:full_width' },
      containerSelector: { type: String, default: '#page-content-wrapper .container-limited' },
      fullWidthClass: { type: String, default: 'container-full-width' },
    };
  }

  static get targets() {
    return ['icon'];
  }

  connect() {
    this.containerElement = document.querySelector(this.containerSelectorValue);
    if (!this.containerElement) return;

    // localStorageから状態を復元
    const stored = localStorage.getItem(this.storageKeyValue);
    this.isFullWidth = stored === 'true';
    this._apply();
  }

  toggle(event) {
    event.preventDefault();
    this.isFullWidth = !this.isFullWidth;
    localStorage.setItem(this.storageKeyValue, this.isFullWidth);
    this._apply();
  }

  _apply() {
    if (!this.containerElement) return;

    if (this.isFullWidth) {
      this.containerElement.classList.add(this.fullWidthClassValue);
    } else {
      this.containerElement.classList.remove(this.fullWidthClassValue);
    }
    this._updateIcon();
  }

  _updateIcon() {
    if (!this.hasIconTarget) return;

    if (this.isFullWidth) {
      this.iconTarget.className = 'fas fa-compress-arrows-alt';
    } else {
      this.iconTarget.className = 'fas fa-expand-arrows-alt';
    }
  }
}
